import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent } from '@mui/material';
import { LANDING_CONTAINER_MAX_WIDTH, landingGridSpacing, landingSectionSpacing } from '@/constants/landingLayout';
import { trustFeatures } from './condominiumProductContent';

export default function CondoTrustSection() {
  return (
    <Box sx={{ ...landingSectionSpacing, bgcolor: 'background.paper' }}>
      <Container maxWidth={LANDING_CONTAINER_MAX_WIDTH}>
        <Typography variant="h4" component="h2" align="center" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
          Uma plataforma feita para a rotina do seu condomínio
        </Typography>
        <Typography
          variant="body1"
          align="center"
          color="text.secondary"
          sx={{ mb: 6, maxWidth: '600px', mx: 'auto', fontSize: '1.1rem' }}
        >
          O V-Condo ajuda síndicos e equipes a organizar a operação, acompanhar cada demanda e manter o histórico de tudo o que acontece.
        </Typography>
        <Grid container spacing={landingGridSpacing.cards}>
          {trustFeatures.map((feature, index) => (
            <Grid item xs={12} sm={4} key={index}>
              <Card
                elevation={2}
                sx={{
                  height: '100%',
                  textAlign: 'center',
                  transition: 'transform 0.3s, box-shadow 0.3s',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: 6,
                  },
                }}
              >
                <CardContent sx={{ p: 3 }}>
                  <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>{feature.icon}</Box>
                  <Typography variant="h6" component="h3" gutterBottom sx={{ fontWeight: 'bold' }}>
                    {feature.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {feature.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}